let map;
let markers = [];
const uniqueDistricts = new Set();
let shops = {}; // Declare shops globally to make it accessible in other functions

async function initMap() {
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  const { ColorScheme } = await google.maps.importLibrary("core");
  const center = { lat: 1.352983, lng: 103.819836 };

  map = new Map(document.getElementById("map"), {
    center,
    zoom: 12,
    mapId: "FIND_A_STORE",
    colorScheme: ColorScheme.FOLLOW_SYSTEM,
    gestureHandling: "greedy",
  });

  //  fetch('{{ section.settings.json_url }}')
  fetch(shopsJsonUrl)
    .then((response) => response.json())
    .then((data) => {
      shops = data; // Assign the fetched data to the global shops variable

      let totalShops = 0;
      Object.keys(shops).forEach((brand) => {
        totalShops += Object.keys(shops[brand].branch).length;
      });

      console.log(`Number of shops returned: ${totalShops}`);
      document.getElementById("total-shops").textContent = `${totalShops} shop${
        totalShops > 1 ? "s" : ""
      }`;
      document.getElementById("last-update").textContent =
        new Date().toLocaleDateString("en-CA");

      fillBrandOptions("brand-filter", shops);
      fillDistrictOptions("district-filter", shops);

      populateStoreList(shops);

      // Add event listeners for filtering
      document
        .getElementById("brand-filter")
        .addEventListener("change", () => populateStoreList(shops));
      document
        .getElementById("district-filter")
        .addEventListener("change", () => populateStoreList(shops));
    })
    .catch((error) => console.error("Error fetching shop data:", error));
}

function fillBrandOptions(id, data) {
  const brandFilter = document.getElementById(id);
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const option = document.createElement("option");
      option.value = key;
      option.textContent = data[key].name_ensg || key;
      brandFilter.appendChild(option);
    }
  }
}

function fillDistrictOptions(id, data) {
  const districtFilter = document.getElementById(id);

  for (const key in data) {
    if (data.hasOwnProperty(key) && data[key].branch) {
      findDistricts(data[key].branch);
    }
  }

  Array.from(uniqueDistricts)
    .sort()
    .forEach((district) => {
      const option = document.createElement("option");
      option.value = district; // Set the value attribute
      option.textContent = district; // Set the display text
      districtFilter.appendChild(option); // Append to the select element
    });
}

function findDistricts(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (typeof value === "object" && value !== null) {
        // Recursively traverse objects
        findDistricts(value);
      } else if (key === "district_ensg") {
        // Add district_ensg value to the Set
        uniqueDistricts.add(value);
      }
    }
  }
}

function populateStoreList(data) {
  const storeList = document.getElementById("store-list");
  storeList.innerHTML = ""; // Clear the store list

  // Clear existing markers
  markers.forEach((marker) => marker.setMap(null));
  markers = [];

  const selectedBrand = document.getElementById("brand-filter").value;
  const selectedDistrict = document.getElementById("district-filter").value;

  let filteredShopCount = 0; // Counter for filtered shops
  const bounds = new google.maps.LatLngBounds(); // To adjust map zoom and center

  Object.keys(data).forEach((brand) => {
    if (selectedBrand && brand !== selectedBrand) return;

    Object.values(data[brand].branch).forEach((branch) => {
      if (selectedDistrict && branch.district_ensg !== selectedDistrict) return;

      // Increment the filtered shop count
      filteredShopCount++;

      // Create the store list item
      const listItem = document.createElement("a");
      listItem.className =
        "list-group-item list-group-item-action d-flex store-item";
      listItem.href = "#";

      // First column: Logo
      const logoColumn = document.createElement("div");
      logoColumn.className = "store-item__logo";
      if (data[brand].logo) {
        const logoImg = document.createElement("img");
        logoImg.src = `https://sagami.sg/${data[brand].logo}`;
        logoImg.alt = `${data[brand].name_ensg} Logo`;
        logoColumn.appendChild(logoImg);
      } else if (data[brand].icon) {
        const logoImg = document.createElement("img");
        logoImg.src = `https://sagami.sg/${data[brand].icon}`;
        logoImg.alt = `${data[brand].name_ensg} Icon`;
        logoColumn.appendChild(logoImg);
      }

      // Second column: Name and Address
      const infoColumn = document.createElement("div");
      infoColumn.className = "store-item__info";
      const name = document.createElement("strong");
      name.textContent = branch.name_ensg;
      const address = document.createElement("div");
      address.textContent = branch.address_ensg;
      infoColumn.appendChild(name);
      infoColumn.appendChild(address);

      // Third column: Modal Button
      const buttonColumn = document.createElement("div");
      buttonColumn.className = "store-item__button";
      const modalButton = document.createElement("button");
      modalButton.className = "modal-toggle";
      modalButton.textContent = "!";
      modalButton.setAttribute("data-branch-id", branch.id);
      buttonColumn.appendChild(modalButton);

      // Append columns to the list item
      listItem.appendChild(logoColumn);
      listItem.appendChild(infoColumn);
      listItem.appendChild(buttonColumn);

      // Append the list item to the store list
      storeList.appendChild(listItem);

      // Add a marker for the branch
      if (branch.lat && branch.lng) {
        const pinImg = `https://sagami.sg/${data[brand].pinimg}`;
        const pinImgActive = `https://sagami.sg/${data[brand].pinimg_h}`;

        // Create a custom marker element
        const markerElement = document.createElement("div");
        markerElement.style.position = "relative";
        markerElement.style.width = "40px";
        markerElement.style.height = "40px";
        markerElement.style.backgroundColor = "transparent"; // Default background
        markerElement.style.display = "flex";
        markerElement.style.alignItems = "center";
        markerElement.style.justifyContent = "center";
        markerElement.style.zIndex = "1"; // Default z-index for markers

        const markerImg = document.createElement("img");
        markerImg.src = pinImg; // Default marker image
        markerImg.style.width = "30px";
        markerImg.style.height = "30px";
        markerElement.appendChild(markerImg);

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map: map,
          position: {
            lat: parseFloat(branch.lat),
            lng: parseFloat(branch.lng),
          },
          title: branch.name_ensg,
          content: markerElement,
        });

        // Extend the bounds to include this marker
        bounds.extend(marker.position);

        const debouncedCenterMap = debounce((position, zoom) => {
          map.setCenter(position);
          map.setZoom(zoom);
        }, 300); // 300ms delay

        // Add click event to the marker
        marker.addListener("gmp-click", () => {
          // Reset all markers
          markers.forEach((m) => {
            const markerContent = m.content;
            if (markerContent) {
              const img = markerContent.querySelector("img");
              if (img) img.src = m.defaultImg; // Reset to the marker's default image
              markerContent.style.zIndex = "1"; // Reset z-index
            }
          });

          // Highlight the clicked marker
          markerImg.src = pinImgActive;
          markerElement.style.zIndex = "10"; // Bring the active marker to the front

          // Update the active list item
          document.querySelectorAll(".store-item").forEach((item) => {
            item.classList.remove("active");
          });
          listItem.classList.add("active");

          // Debounced map centering
          debouncedCenterMap(marker.position, 15);
        });

        // Add click event to the list item
        listItem.addEventListener("click", () => {
          // Reset all markers
          markers.forEach((m) => {
            const markerContent = m.content;
            if (markerContent) {
              const img = markerContent.querySelector("img");
              if (img) img.src = m.defaultImg; // Reset to the marker's default image
              markerContent.style.zIndex = "1"; // Reset z-index
            }
          });

          // Highlight the clicked marker
          markerImg.src = pinImgActive;
          markerElement.style.zIndex = "10"; // Bring the active marker to the front

          // Update the active list item
          document.querySelectorAll(".store-item").forEach((item) => {
            item.classList.remove("active");
          });
          listItem.classList.add("active");

          // Debounced map centering
          debouncedCenterMap(marker.position, 15);
        });

        // Store the marker and its default image
        marker.defaultImg = pinImg; // Store the default image for this marker
        markers.push(marker);
      }
    });
  });

  // Adjust the map to fit all filtered markers
  if (filteredShopCount > 0) {
    map.fitBounds(bounds); // Adjust zoom and center to fit all markers
  } else {
    map.setCenter({ lat: 1.352983, lng: 103.819836 }); // Default center
    map.setZoom(12); // Default zoom
  }

  // Update the total shop count
  document.getElementById(
    "total-shops"
  ).textContent = `${filteredShopCount} shop${
    filteredShopCount > 1 ? "s" : ""
  }`;
}

initMap();

document.getElementById("reset-filters").addEventListener("click", (event) => {
  event.preventDefault(); // Prevent the default link behavior

  // Reset the filters to their default values
  document.getElementById("brand-filter").value = "";
  document.getElementById("district-filter").value = "";

  // Repopulate the store list and update the map markers
  populateStoreList(shops);
});

document.addEventListener("click", (event) => {
  if (event.target.classList.contains("modal-toggle")) {
    const branchId = event.target.getAttribute("data-branch-id");

    // Find the corresponding branch details
    let shopDetails = null;
    let branchDetails = null;
    Object.keys(shops).forEach((brand) => {
      Object.values(shops[brand].branch).forEach((branch) => {
        if (branch.id === branchId) {
          shopDetails = shops[brand];
          branchDetails = branch;
        }
      });
    });

    if (branchDetails) {
      // Populate the modal content
      const modalContent = document.getElementById("modal-content");
      modalContent.innerHTML = `
        ${
          branchDetails.logo?
            '<img src="https://sagami.sg/' + branchDetails.logo + '" alt="" />':
          shopDetails.logo
            ? '<img src="https://sagami.sg/' + shopDetails.logo + '" alt="" />'
            : ""
        }
        <h3>${branchDetails.name_ensg}</h3>
        ${
          branchDetails.address_ensg
            ? "<p><strong>Address:</strong>" +
              branchDetails.address_ensg +
              "</p>"
            : ""
        }
        ${
          branchDetails.url
            ? "<p><strong>URL:</strong> " + branchDetails.url + "</p>"
            : ""
        }
        <p><strong>Opening hours:</strong> ${branchDetails.hours}</p>
        <p><strong>Telephone:</strong> ${branchDetails.tel}</p>
      `;

      // Show the modal
      const modal = new bootstrap.Modal(document.getElementById("storeModal"), {
        backdrop: true, // Enable backdrop
        focus: true, // Focus on the modal
      });
      modal.show();
    } else {
      console.error("Branch details not found for ID:", branchId);
      return;
    }
  }
});
